import React, { useState, useMemo } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit2, FiTrash2, FiSearch, FiTruck } = FiIcons;

export default function SupplierTable({ suppliers, onEdit, onDelete, isAdmin, canEdit }) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredSuppliers = useMemo(() => {
    return suppliers.filter(supplier => {
      const searchLower = searchTerm.toLowerCase();
      return (
        supplier.name.toLowerCase().includes(searchLower) ||
        (supplier.contact && supplier.contact.toLowerCase().includes(searchLower)) ||
        (supplier.phone && supplier.phone.toLowerCase().includes(searchLower))
      );
    });
  }, [suppliers, searchTerm]);

  if (suppliers.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-12 bg-white rounded-xl shadow-sm border border-gray-200 text-center">
        <div className="h-16 w-16 bg-gray-50 rounded-full flex items-center justify-center mb-4">
          <SafeIcon icon={FiTruck} className="text-3xl text-gray-400" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-1">No hay proveedores</h3>
        <p className="text-gray-500">Aún no hay proveedores registrados.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <SafeIcon icon={FiSearch} className="text-gray-400" />
          </div>
          <input
            type="text"
            placeholder="Buscar por nombre, contacto o teléfono..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 w-full md:w-1/2 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
          />
        </div>
      </div>

      {filteredSuppliers.length === 0 ? (
        <div className="flex flex-col items-center justify-center p-12 bg-white rounded-xl shadow-sm border border-gray-200 text-center">
          <div className="h-16 w-16 bg-gray-50 rounded-full flex items-center justify-center mb-4">
            <SafeIcon icon={FiSearch} className="text-3xl text-gray-400" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-1">No se encontraron resultados</h3>
          <p className="text-gray-500">No hay proveedores que coincidan con tu búsqueda.</p>
          <button
            onClick={() => setSearchTerm('')}
            className="mt-4 text-indigo-600 hover:text-indigo-800 font-medium transition-colors"
          >
            Limpiar búsqueda
          </button>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 text-sm font-medium text-gray-600">
                  <th className="px-6 py-4">Empresa / Nombre</th>
                  <th className="px-6 py-4">Contacto</th>
                  <th className="px-6 py-4">Teléfono</th>
                  {canEdit && <th className="px-6 py-4 text-right">Acciones</th>}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredSuppliers.map((supplier) => (
                  <tr key={supplier.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 font-medium text-gray-900">{supplier.name}</td>
                    <td className="px-6 py-4 text-gray-600">{supplier.contact || '-'}</td>
                    <td className="px-6 py-4 text-gray-600">{supplier.phone || '-'}</td>
                    
                    {canEdit && (
                      <td className="px-6 py-4 text-right space-x-2">
                        <button
                          onClick={() => onEdit(supplier)}
                          className="p-2 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors"
                          title="Editar"
                        >
                          <SafeIcon icon={FiEdit2} />
                        </button>
                        {isAdmin && (
                          <button
                            onClick={() => {
                              if (window.confirm('¿Estás seguro de que deseas eliminar este proveedor?')) {
                                onDelete(supplier.id);
                              }
                            }}
                            className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            title="Eliminar"
                          >
                            <SafeIcon icon={FiTrash2} />
                          </button>
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}